<template>
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label>
                Nombre Completo de Titular:
                <span class="text-danger lb-error" v-if="!$v.domicilio.nombre_domicilio.required">* Campo requerido</span>
              </label>
              <input
                type="text"
                placeholder="Ej.: Maria Paredes"
                class="form form-control"
                :class="{'is-invalid': $v.domicilio.nombre_domicilio.$error}"
                v-model.trim="domicilio.nombre_domicilio"
                @keyup="domicilio.nombre_domicilio = domicilio.nombre_domicilio.toUpperCase()"
              />
            </div>
          </div>
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label>
                Tipo Documento:
                <span class="text-danger lb-error" v-if="!$v.domicilio.par_tipo_documento.required">* Campo requerido</span>
              </label>
              <select
                class="form-control"
                :class="{'is-invalid': $v.domicilio.par_tipo_documento.$error}"
                v-model="domicilio.par_tipo_documento"
              >
                <option value="">SELECCIONAR</option>
                <option v-for="(item, index) in tipoDocumentos" :value="item.codigo" :key="index">{{ item.nombre }}</option>
              </select>
            </div>
          </div>  
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label>
                Nro Documento Titular:
                <span class="text-danger lb-error" v-if="!$v.domicilio.nro_documento.required">* Campo requerido</span>
              </label>
              <input
                type="text"
                class="form form-control"
                placeholder="Ej.: 3548874"
                :class="{'is-invalid': $v.domicilio.nro_documento.$error}"
                v-model.trim="domicilio.nro_documento"
              />    
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label>
                Departamento:
                <span class="text-danger lb-error" v-if="!$v.domicilio.departamento.required">* Campo requerido</span>
              </label>
              <select
                class="form form-control"
                :class="{'is-invalid': $v.domicilio.departamento.$error}"
                v-model="domicilio.departamento"
              >
                <option value="">SELECCIONAR</option>
                <option v-for="(item, index) in departamentos" :value="item.codigo_departamento" :key="index">{{item.nombre_departamento}}</option>
              </select>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label class="">
                Dirección:
                <span class="text-danger lb-error" v-if="!$v.domicilio.direccion.required">* Campo requerido</span>
              </label>
              <input
                type="text"
                placeholder="Ej.: Av. 6 de Agosto"
                class="form form-control"
                :class="{'is-invalid': $v.domicilio.direccion.$error}"
                v-model.trim="domicilio.direccion"
                @keyup="domicilio.direccion = domicilio.direccion.toUpperCase()"
              />    
            </div>
          </div>
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label class="">
                Teléfono:
                <span class="text-danger lb-error" v-if="!$v.domicilio.telefono.required">* Campo requerido</span>
              </label>
              <input
                type="number"
                placeholder="Ej.: 5225500"
                v-model="domicilio.telefono"
                class="form form-control"
              />    
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label>
                Fecha Inicio:
                <span class="text-danger lb-error" v-if="!$v.domicilio.fecha_inicio.required">* Campo requerido</span>
              </label>
              <input
                type="date"
                class="form form-control"
                :min="fechaMin"
                :class="{'is-invalid': $v.domicilio.fecha_inicio.$error}"
                v-model="domicilio.fecha_inicio"
                @change="onChangeFechaIni($event)"
              />
            </div>
          </div>
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label>
                Fecha Fin:
                <span class="text-danger lb-error" v-if="!$v.domicilio.fecha_fin.required">* Campo requerido</span>
              </label>
              <input
                type="date"
                id="fecha_fin_d"
                class="form form-control"
                :class="{'is-invalid': $v.domicilio.fecha_fin.$error}"
                :min="fechaMin"
                v-model="domicilio.fecha_fin"
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  
</template>

<script>
import {required} from "vuelidate/lib/validators";
import moment from 'moment';

export default {
  props:{
    domicilio: Object
  },
  data() {
    return {
      // domicilio: {
      //   id_persona: 0,
      //   id_empresa: '',
      //   tipo_domicilio: "HOS",
      //   nombre_domicilio: "",
      //   direccion: "",
      //   telefono: "",
      //   fecha_inicio: null,
      //   fecha_fin: null,
      //   tipo_documento: "",
      //   nro_documento: "",
      //   departamento: "",
      // },
      departamentos: [],
      tipoDocumentos: [],
      fechaMin: new moment().format("YYYY-MM-DD"),
    }
  },
  methods: {
    async getDepartamentos() {
      let config = { headers: { token: this.token } };
      try {
        let resultado = await this.axios.get(`/getDepartamentos`, config);
          this.departamentos = resultado.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async getTipoDocumento() {
      try {
        await this.axios
          .get(`/getParametros/DOCUMENTO`)
          .then((response) => {
            this.tipoDocumentos = response.data.contenido;
          })
          .catch((error) => {
            console.log('catch: ', error);
          });
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    onChangeFechaIni(event){
      let fecha = event.target._value;
      document.getElementById("fecha_fin_d").setAttribute("min",fecha);
    },

  },
  created () {
    this.getDepartamentos();
    this.getTipoDocumento();
  },
  validations: {
    domicilio: {
      nombre_domicilio: {required},
      par_tipo_documento: {required},
      nro_documento: {required},
      departamento: {required},
      direccion: {required},
      telefono: {required},
      fecha_inicio: {required},
      fecha_fin: { required },
    },
  },

}
</script>